import { useLoadingAnimation } from '@/components/LoadingAnimation/useLoadingAnimation.hook';
import { DEFAULT_ERROR_MESSAGE } from '@/config/text.const';
import { upliftHttpClient } from '@/services/http/clients/upliftHttpClient';
import { notificationService } from '@/services/notification/notification.client';

export function useAbandonUpliftFile() {
  const { toggleLoadingAnimation } = useLoadingAnimation();

  const abandonFile = (id: UUID, callback?: Function) => {
    toggleLoadingAnimation(true);

    const requestUrl = `/Documents/${id}`;
    upliftHttpClient.delete(requestUrl)
      .then(() => {
        notificationService.open({
          title: 'Abandon uplift file',
          text: 'File successfully abandoned',
          type: 'success'
        });

        if (typeof callback === 'function') {
          callback();
        }
      })
      .catch((err) => notificationService.open({
        title: 'Error',
        text: err?.message ?? DEFAULT_ERROR_MESSAGE,
        type: 'danger'
      }))
      .finally(() => toggleLoadingAnimation(false));
  };

  return {
    abandonFile
  } as const;
}
